// extracted by mini-css-extract-plugin
export default {"emptyList":"emptyList---xZN5Q"};